import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VideoThreadsInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';

const VideoThreadsInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ count, setCount ] = useState<number>(project.encoder.transcoderVideoThreads);
  const debounce = 500;
  const min = 1;
  const max = 32;

  const onAfterChange = (data: string) => {
    if (project.encoder) {
      let value = count;

      if (value < min) {
        value = min;
      } else if (value > max) {
        value = max;
      }
      
      setCount(value);

      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          transcoderVideoThreads: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoThreads: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setCount(project.encoder.transcoderVideoThreads);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.transcoderVideoThreads]);

  return (
    <div className="video-threads-input">
      <div className="input-title">{t('producer.inputs.video-threads.title')}</div>
      <TextInput
        placeholder="producer.inputs.video-threads.placeholder"
        value={count.toString()}
        onChange={(value) => {setCount(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">{t('producer.inputs.video-threads.footer')}</div>
    </div>
  );
};

export default React.memo(VideoThreadsInput);
